import app from '../authentication/firebaseStart';
export class PlaySoundService {
    firestore = app.firestore();
    async addPlaySoundSetting(tenantId, data) {
        /*deviceSound: deviceSound,
        volumeLevel: volumeLevel,
        replayInterval: replayInterval,
        playSoundType:playSoundType,
        replayDuration:audioDurationValue
        */
        try{
            const playSettingDoc = {
                audioDuration:data.replayDuration,
                audioInterval:data.replayInterval,
                playSoundType:data.playSoundType,
                volumeLevel:data.volumeLevel,
                audioFileOnDevice:data.audioFileOnDevice,
                audioCustomTone:data.audioCustomTone
    
            }
            return await this.firestore
                .collection("tenants")
                .doc(tenantId)
                .collection("Configuration").doc("AppSettings").collection('Notifications').doc('PlaySound').set(playSettingDoc, {merge:true});
        }catch(err){
            return Promise.reject({status:false,msg:"Error in saving Playsound Settings"})
        }
    };

    async getPlaySoundSetting(tenantId){
        try{

            let doc = await this.firestore
            .collection("tenants")
            .doc(tenantId)
            .collection("Configuration").doc("AppSettings").collection('Notifications').doc('PlaySound').get();
            if(!doc.exists){
                /**
                 * if not document, then return default values object
                */
               return {
                    audioDuration: 0,
                    audioInterval: 0,
                    playSoundType: 0,
                    volumeLevel: 100,
                    audioFileOnDevice: "",
                    audioCustomTone:""
               }
            }else{
                return doc.data();
            }
        }catch(err){
            return Promise.reject({status:false, msg:'Internal Server Error'})
        }
         
       
    }
}